/**
 * Sentry `environment` tag shared by the Worker and the browser entry, so the
 * preview deployment reports as its own environment instead of "production".
 * Universal (no Node-only imports). Aliases: sentry environment, preview tag.
 */

/**
 * Returns the configured environment (`SENTRY_ENVIRONMENT` on the Worker,
 * `VITE_SENTRY_ENVIRONMENT` in the browser build) or, when none is set, the
 * Vite mode ("production" in a production build).
 */
export function resolveSentryEnvironment(
  configured: string | undefined,
  mode: string,
): string {
  return configured || mode;
}
